import { createContext, useContext } from 'react';

import type { AccountContextType } from './types';

export const defaultAccountContext: AccountContextType = {
  customer: null,
  customers: [],
  features: {},
  featuresLoading: false,
  hasReleaseToggle: () => false,
  loading: false,
  setCustomerId: () => {},
  user: null as any,
  refetchUser: () => {},
  currentOrgHasDeliveryRelationshipsAsPartner: false,
  currentUserOrganizationRecordPermissions: [],
  canAssignAPIKeys: false,
  isDataAdmin: false,
  canManageUsers: false,
  collaboratorCostManagement: false,
};

export const AccountContext = createContext<AccountContextType>(defaultAccountContext);

export function useAccountContext() {
  return useContext(AccountContext);
}
